<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <form [formGroup]="customerDetailsForm">
    <ion-label class="title">{{ 'ACCOUNT.email.enter' | translate }}</ion-label>
    <ion-item class="item-input item-interactive" mode="md">
      <ion-input
        label="{{ 'ACCOUNT.email.new' | translate }}"
        labelPlacement="stacked"
        autocomplete="email"
        type="text"
        (keyup.enter)="updateEmail()"
        formControlName="email"
      ></ion-input>
    </ion-item>
    <div class="ion-input__errors">
      <span *ngIf="customerDetailsForm.controls.email.hasError('required') && customerDetailsForm.touched">
        {{ 'ACCOUNT.email.please' | translate }}
      </span>
      <span *ngIf="customerDetailsForm.controls.email.hasError('email') && customerDetailsForm.touched">
        {{ 'PUBLIC.email.incorrectFormat' | translate }}
      </span>
    </div>
    <ion-button (click)="updateEmail()" mode="ios">{{ 'SHARED.actions.saveChanges' | translate }}</ion-button>
  </form>
</ion-content>
